import { Container, Grid, Typography } from "@material-ui/core";
import React from "react";

const index = () => {
  return (
    <Container>
      <Grid container spacing={4} justifyContent="center" style={{ marginTop: 48 }}>
        <Grid item xs={12} lg={8}>
          <Typography variant="h1" component="h1" style={{ fontSize: 68 }}>
            Reanibex Services
          </Typography>

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h3" component="h3" style={{ marginTop: 50 }}>
                Política de Privacidad
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Bexen Cardio se compromete a proteger su privacidad. Esta declaración de privacidad sólo se aplica a los datos personales de los usuarios que hacen uso del sitio
                web rdn.bexencardio.com y las aplicaciones/servicios/plataformas asociadas al servicio de monitorización de equipos de Bexen Cardio - Reanibex Data Net, Reanibex
                Alert, Reanibex Training, Reanibex Usb Sync y Reanibex NFC Reader - y no se aplica al sitio web corporativo{" "}
                <a href="https://www.bexencardio.com" target="_blank">
                  www.bexencardio.com
                </a>
                , ni otro subdominio de bexencardio.com o aplicaciones, ni tampoco se aplica a Osatu S. Coop. en el contexto de sus actividades corporativas. Consulte las
                declaraciones de privacidad de esos sitios web/aplicaciones/contratos para obtener más información al respecto.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                ¿Qué información se recopila de los usuarios?
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Los servicios del sistema de monitorización de equipos de Bexen Cardio únicamente recopilan datos personales para la creación y gestión de las cuentas de usuarios,
                en concreto de los usuarios que usan la página, y no de los pacientes que son tratados con los equipos. Se almacenan: el email, nombre, apellidos y número de
                teléfono.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Cuando utilizas los servicios de Bexen Cardio, Bexen Cardio no recoge datos para fines estadísticos ni de creación de perfiles, de usuarios registrados o no
                registrados. Tampoco se recogen datos con fines publicitarios ni de marketing para ningún tipo de usuario. Podremos usar algunos de los datos en trabajos de
                investigación y desarrollo para mejorar nuestros servicios y productos, siempre eliminando los identificadores y anonimizando los datos en aquellos casos en los que
                fuera necesarios. Equipos como el R100 y sus herramientas - Reanibex Data Net, Usb Sync, Reanibex NFC Reader -, no almacenan datos identificativos del paciente.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                A través de los servicios de la plataforma Reanibex Data Net de Bexen Cardio, puedes gestionar tú mismo tus datos de usuario personales. Te recomendamos que
                compruebes de vez en cuando la exactitud de los datos y que los corrijas si fuera necesario. Eres el responsable de la precisión de los datos que nos facilitas.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                ¿Con quién se comparten mis datos?
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Bexen Cardio no comparte tus datos con nadie excepto para poder ofrecer el servicio contratado. En concreto: Proveedores de servicios en la nube: para tener la
                plataforma accesible a través de internet, es necesario alojarla en la nube, que proporcionen las suficientes medidas de seguridad. En concreto se utilizan
                servidores en la nube donde se encuentran alojados tanto las aplicaciones como los datos necesarios para dar el servicio.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Además, en el caso de los usuarios registrados, las entidades y/o clientes (responsables del tratamiento) que contrataron el servicio, son los responsables de
                gestionar entre otras cosas los usuarios que acceden al servicio (cada entidad/cliente tiene sus propios usuarios y no tendrá acceso a los de otras/os
                entidades/clientes).
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Bexen Cardio nunca revela tus datos personales sin tu permiso específico, a menos que sea necesario para gestionar tu pedido, llevar a cabo tu solicitud o
                administrar nuestros programas interactivos para clientes. Sin embargo, la información podrá divulgarse si así lo requiere la ley, una orden judicial o una
                normativa o solicitud emitida por las autoridades.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                ¿Dónde se almacena la información?
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Tal y como se ha explicado en el punto anterior, este servicio utiliza proveedores de servicios en la nube que se encuentran dentro del espacio Económico Europeo y
                que se comprometen a no transferir los datos fuera del espacio económico Europeo. La duración de los datos en el servicio viene dada por el contrato por escrito
                contraído con la entidad o cliente que contrató el servicio (responsables del tratamiento) y que le dió acceso a este.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                ¿Cuáles son tus derechos?
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Los usuarios registrados pueden solicitar el acceso, modificación o eliminación de cualquiera de sus propios datos personales, no así otros datos o datos de otros
                usuarios.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Siempre tienes derecho a acceder a tus datos personales. Para algunos de nuestros servicios, necesitamos que nos des tu consentimiento. Solicitamos tu
                consentimiento sólo en los casos en los que sea necesario para ofrecer el servicio. Tienes derecho a retirar tu consentimiento en cualquier momento. Tienes derecho
                a modificar tus datos en cualquier momento. Tienes derecho a la portabilidad de tus datos, pero esto solo se aplica a los datos proporcionados por ti. En la mayoría
                de los servicios, el acceso directo es posible y si es necesario puedes solicitar información en <a href="mailto:info@bexencardio.com">info@bexencardio.com</a>.
                Para verificar tu identidad y poder realizar tu solicitud, es posible que debamos pedirte más datos.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Bexen Cardio puede gestionar tus datos personales cuando la manipulación se basa en un interés legítimo. En algunos casos utilizamos esta base legal para nuestras
                actividades de investigación y desarrollo, para mejorar la calidad de nuestros servicios y productos. Tienes derecho a oponerte a la gestión de tus datos personales
                para dichos propósitos. Puedes revocar el tratamiento de tus datos con fines de investigación y desarrollo en la aplicación o plataforma correspondiente.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Tienes derecho a que se eliminen tus datos. Si quieres que eliminemos tus datos, eliminaremos tus credenciales de usuario así como toda información y datos que te
                pertenezcan. Esto incluye los datos de todos aquellos servicios/aplicaciones del sistema de monitorización de equipos de Bexen Cardio, de los que hayas hecho uso.
                Los datos eliminados no podrán recuperarse. Una vez eliminados, solo podrás utilizar el servicio si creas una nueva cuenta de usuario. Según lo requerido por las
                disposiciones imperativas de la ley, algunos de tus datos, como la información de compra, se conservarán por algún tiempo.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Para algunos de nuestros servicios, necesitamos que nos des tu consentimiento. Solicitamos tu consentimiento sólo en los casos en los que sea necesario para ofrecer
                el servicio. Tienes derecho a retirar tu consentimiento en cualquier momento. Debes tener en cuenta que, en algunos servicios, la retirada del consentimiento nos
                impide ofrecer el servicio en sí.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                Seguridad
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Una de las dificultades presentes al tratar datos es que siempre hay riesgos asociados con el procesamiento de datos personales, y no existe ningún sistema que
                permita garantizar al cien por cien la seguridad de estos. Bexen Cardio usa medidas de seguridad técnicas y organizativas para garantizar la adquisición, acceso y
                procesamiento seguro de los datos. Bexen Cardio además usa servicios cloud de proveedores reconocidos que garantizan altos estándares de seguridad y que cumple con
                estándares de seguridad como la ISO/IEC 27001.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Así mismo, se dispone de sistemas de “backup” que permite la recuperación de datos en caso de pérdida o de que se corrompan.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h3" component="h3" style={{ marginTop: 30, textAlign: "justify" }}>
                Cookies y Terceros
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                ¿Qué es una Cookie?
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Una Cookie es un archivo inofensivo que se guarda en el navegador web casi cada vez que se visita un sitio web.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Este archivo permite que un sitio web sea capaz de recordar su visita cuando vuelva a navegar por esa página. Por ejemplo, para que el sitio recuerde el idioma
                seleccionado la última vez que accedió.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Este archivo también se puede usar para mantener abierta una sesión de usuario. Por ejemplo, si hace login en un sitio web para que mientras navega por él, este
                sepa que es un usuario registrado y le muestre el sitio y los datos acordes a su cuenta.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                ¿Qué tipo de Cookies existen?
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Las Cookies pueden realizar diferentes tareas y en función de estas las Cookies se pueden dividir en los siguientes tipos:
              </Typography>
              <ul style={{ paddingLeft: "1.5rem", marginTop: 15 }}>
                <li>
                  <Typography style={{ textAlign: "justify" }}>
                    Cookies técnicas:permiten entre otras cosas mantener configuraciones que se hayan hecho del sitio, por ejemplo, el idioma seleccionado de un sitio web para que
                    se vea en todas las páginas de este sitio. También son usadas para mantener una sesión de usuario abierta, por ejemplo si hace login en un sitio web para que
                    cuando navegue por el sitio, éste sepa que sigue siendo usted.
                  </Typography>
                </li>
                <li style={{ marginTop: 10 }}>
                  <Typography style={{ textAlign: "justify" }}>
                    Cookies de análisis: recogen información sobre el tipo de navegación que está realizando, las secciones más visitadas, productos consultados, idioma, etc.
                  </Typography>
                </li>
                <li style={{ marginTop: 10 }}>
                  <Typography style={{ textAlign: "justify" }}>
                    Cookies publicitarias: muestran publicidad en función de su navegación, su país de procedencia, idioma, etc.
                  </Typography>
                </li>
              </ul>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                ¿Qué Cookies utiliza este sitio?
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Bexen Cardio utiliza herramientas de Google y Microsoft Azure. Sin embargo, sin tu permiso no se comparte ningún dato personal relacionado con los servicios dados
                por Bexen Cardio a estos proveedores de servicios.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Las plataformas y aplicaciones del servicio de monitorización de equipos de Bexen Cardio únicamente utilizan Cookies de sesión:
              </Typography>

              <ul style={{ paddingLeft: "1.5rem", marginTop: 15 }}>
                <li>
                  <Typography style={{ textAlign: "justify" }}>
                    authCookie: son cookies técnicas, necesarias para mantener la sesión de usuario abierta y poder navegar por el área privada de la cuenta sin problemas.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ textAlign: "justify" }}>
                    ARRAffinity / ARRAffinitySameSite: son cookies técnicas de los servicios de Microsoft Azure necesarias para llevar a cabo el balanceo de carga de los servicios
                    cloud de los que provee Azure a Bexen Cardio para poder alojar la plataforma Reanibex Data Net.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ textAlign: "justify" }}>
                    i18nextLng: son cookies técnicas usadas en la plataforma de Reanibex Training para personalizar el interfaz con el idioma seleccionado en la plataforma.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ textAlign: "justify" }}>
                    firebase:host:reanibex-training.firebaseio.com: son cookies técnicas que mantienen la sesión de usuario en los servicios de Google Firebase, necesarias para los
                    servicios de los que provee Google Firebase a Bexen Cardio encargados de alojar la plataforma Reanibex Training y la app Reanibex Alert.
                  </Typography>
                </li>
                <li>
                  <Typography style={{ textAlign: "justify" }}>
                    Firebase:host:reanibex-training-fc2ad.europe-west1.firebasedatabase.app: son cookies técnicas que mantienen la sesión a los servicios de Google Firebase,
                    necesarias para los servicios de los que provee Google Firebase a Bexen Cardio para alojar la plataforma Reanibex Training y la app Reanibex Alert.
                  </Typography>
                </li>
              </ul>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Estas plataformas utilizan principalmente cookies de técnicas, usadas para autentificar a los usuarios y permitir a los usuarios el acceso a zonas privadas del
                sitio web, en función de los privilegios de cada tipo de usuario.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                También se usan cookies para personalizar el idioma en el que se muestra el sitio web una vez autenticado al usuario.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Finalmente, se usan cookies de sesión para equilibrar la carga por parte de los servicios de Windows Azure y proveer de un servicio con disponibilidad alta.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Según el Grupo de Trabajo del Artículo 29 en su Dictamen 4/20123 que interpreta que entre las cookies exceptuadas estarían aquellas que tienen por finalidad:
              </Typography>
              <ul style={{ paddingLeft: "1.5rem", marginTop: 15 }}>
                <li>
                  <Typography style={{ textAlign: "justify" }}>Cookies de «entrada del usuario».</Typography>
                </li>
                <li>
                  <Typography style={{ textAlign: "justify" }}>Cookies de autenticación o identificación de usuario (únicamente de sesión).</Typography>
                </li>
                <li>
                  <Typography style={{ textAlign: "justify" }}>Cookies de seguridad del usuario.</Typography>
                </li>
                <li>
                  <Typography style={{ textAlign: "justify" }}>Cookies de sesión de reproductor multimedia.</Typography>
                </li>
                <li>
                  <Typography style={{ textAlign: "justify" }}>Cookies de sesión para equilibrar la carga.</Typography>
                </li>
                <li>
                  <Typography style={{ textAlign: "justify" }}>Cookies de personalización de la interfaz de usuario.</Typography>
                </li>
                <li>
                  <Typography style={{ textAlign: "justify" }}>Cookies de complemento (plug-in) para intercambiar contenidos sociales.</Typography>
                </li>
              </ul>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Se puede considerar que las cookies usadas en este sitio (cookies de autenticación y de personalización que no recogen datos personales) quedan exentas de los
                establecido el artículo 22 de la LSSI.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                ¿Puedo desactivar el uso de Cookies?
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Sí. Sin embargo, al ser cookies técnicas el uso de Cookies únicamente se puede desactivar desde el mismo navegador. Un navegador es la aplicación que se usa para
                ver los sitios web. Además, si bloqueas el uso de Cookies globalmente, este cambio afectará a todos los sitios web que visites.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                ¿Qué ocurre si desactivo las Cookies?
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Al desactivar las Cookies técnicas el comportamiento de un sitio web puede variar dependiendo del sitio en sí y del tipo de Cookies que se estén usando.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                En el caso de estas plataformas y aplicaciones, se usan Cookies técnicas - tal y como se explicó en los puntos anteriores - que permiten a un usuario mantener su
                sesión de usuario mientras navega el sitio web. Por tanto, si desactiva las Cookies en su navegador no resultará posible mantener la sesión de usuario abierta con
                lo que no será posible acceder a la zona de usuario registrado.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                ¿Puedo eliminar y/o desactivar las Cookies de este sitio?
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                En cualquier momento puedes desactivar o eliminar las Cookies de este sitio web desde tu navegador. La forma en la que se realiza la eliminación de estas Cookies
                dependerá ampliamente del navegador que se está utilizando para navegar/acceder al sitio web. Así mismo, los pasos de configuración de las Cookies en un navegador
                pueden variar dependiendo de la versión de este.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Más adelante se explica cómo bloquear y eliminar Cookies. Sin embargo, se recomienda ampliamente que no se haga esto si se quiere mantener la sesión de usuario
                abierta mientras navega el sitio. Así mismo, si no se dispone de los conocimientos necesarios pero aún así quieres desactivar/eliminar las Cookies, contacta con su
                administrador de sistemas.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Finalmente, es importante entender que si desactivas y/o eliminas las Cookies en tu navegador es posible que esto no sólo afecte a este sitio web sino que también
                afecte al resto de sitios web que estés visitando.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                Bloqueo de Cookies
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                En algunos navegadores, el bloqueo de Cookies es a nivel de navegador con lo que es posible que estos cambios puedan afectar al resto de sitios web que estás
                visitando con el navegador. Se recomienda ampliamente que revises los manuales y/o documentos de ayuda de tu versión de navegador antes de realizar cualquier
                modificación y/o consulta a un experto. Es posible que los ejemplos aquí expuestos varíen respecto a la versión de tu navegador instalada.
              </Typography>

              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Para realizar el bloqueo de Cookies en algunos de estos navegadores, se puede, por ejemplo, (a día de la redacción de este documento) realizar los siguientes pasos:
              </Typography>

              <ul style={{ paddingLeft: "1.5rem", marginTop: 15 }}>
                <li>
                  <Typography style={{ textAlign: "justify" }}>
                    Mozilla Firefox: ve a la página de login del sitio. Haz click derecho sobre la página y seleccione la opción Ver información de página. En la ventana de
                    Información, seleccione el panel Permisos. Bajo Establecer cookies, selecciona la opción Usar predeterminado y seleccione la opción Bloquear.
                  </Typography>
                </li>
                <li style={{ marginTop: 10 }}>
                  <Typography style={{ textAlign: "justify" }}>
                    Google Chrome: vaya a la página de login de este sitio. Haga click sobre el candado verde en la parte izquierda de la barra de navegación. Seleccione la opción
                    Cookies. En la nueva ventana seleccione cloud.bexencardio.com y haga click sobre el botón Bloquear, después pulse sobre el botón Listo. Finalmente, haga click
                    sobre el botón recargar. Este debería tanto cargar como borrar las cookies de este sitio web.
                  </Typography>
                </li>
              </ul>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                Notas Adicionales
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <ul style={{ paddingLeft: "1.5rem", marginTop: 15 }}>
                <li>
                  <Typography style={{ textAlign: "justify" }}>
                    Bexen Cardio no se hace responsable ni del contenido ni de la veracidad de las políticas de privacidad que puedan tener los terceros mencionados en esta
                    política de cookies.
                  </Typography>
                </li>
                <li style={{ marginTop: 10 }}>
                  <Typography style={{ textAlign: "justify" }}>
                    Bexen Cardio no se hace responsable por cualquier daño que pueda ocasionar la desactivación, modificación y/o eliminación de Cookies en su navegador siguiendo
                    los pasos expuestos más arriba.
                  </Typography>
                </li>
                <li style={{ marginTop: 10 }}>
                  <Typography style={{ textAlign: "justify" }}>
                    Los navegadores web son las herramientas encargadas de almacenar las cookies y desde este lugar debe efectuar su derecho a eliminación o desactivación de las
                    mismas. Ni esta web ni sus representantes legales pueden garantizar la correcta o incorrecta manipulación de las cookies por parte de los mencionados
                    navegadores.
                  </Typography>
                </li>
                <li style={{ marginTop: 10 }}>
                  <Typography style={{ textAlign: "justify" }}>
                    Para cualquier duda o consulta acerca de esta política de cookies no dude en comunicarse con nosotros a través de:{" "}
                    <a href="mailto:info@bexencardio.com">info@bexencardio.com</a>
                  </Typography>
                </li>
              </ul>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h3" component="h3" style={{ marginTop: 30, textAlign: "justify" }}>
                Responsable de Tratamiento
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Aquí se pueden ver una serie de puntos para ayudar a las entidades y/o clientes que han contratado el servicio o adquirido un dispositivo Reanibex que le pueda dar
                acceso a los servicios de Bexen Cardio y los han usado para crear cuentas en los servicios de Reanibex Data Net, USB Sync y Reanibex NFC Reader.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Los siguientes puntos están únicamente como ayuda, pero no alteran de ninguna forma el contrato por escrito contraído entre Bexen Cardio y la entidad y/o cliente
                que contrató el servicio, ni el contrato “Marco de Licencia de Software / Reanibex 100”.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                ¿Cuál es la figura de Bexen Cardio bajo este contrato?
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                La tarea principal de Bexen Cardio, dentro del marco de este servicio, es la de almacenar y tratar los datos pertenecientes a las entidades y/o clientes que
                contrataron el servicio. Por tanto, en este caso Bexen Cardio se puede considerar como el encargado del tratamiento.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                ¿Cuál es la figura de la entidad y/o cliente contratante del servicio?
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                En este caso la relación entre la entidad/cliente y Bexen Cardio consiste en que Bexen Cardio almacena y trata datos pertenecientes a la entidad/cliente. Por tanto,
                en este caso la entidad y/o cliente es el responsable del tratamiento en relación a la GDPR, o el equivalente a responsable de fichero para la LOPD.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                ¿Cuáles son las responsabilidades de Bexen Cardio?
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                El encargado del tratamiento, en este caso Bexen Cardio, realizará los tratamientos según el uso y condiciones de los servicios contratados - “Contrato Marco de
                Licencia de Software Reanibex 100” - , o según otras instrucciones concretadas en un contrato donde se especifiquen estas condiciones.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Bexen Cardio toma las medidas de seguridad y organizativas suficientes para mantener la seguridad e integridad de los datos. Así como asegurar la confidencialidad
                de los datos tratados y/o almacenados en el servicio contratado.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Los datos no saldrán del espacio Económico Europeo, ni por parte de los servicios de Bexen Cardio, ni por parte de ningún proveedor de servicios cloud subcontratado
                para llevar a cabo el servicio.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                La entidad/cliente será responsable únicamente de establecer cuentas en países y jurisdicciones en las que las agencias reguladoras locales han aprobado el uso de
                nuestros productos, software y servicios, y de asegurar que el procesado de datos y la política de privacidad en conformidad a la legislación local vigente en
                materia de protección de datos. Esta restricción se aplica a ti, al cliente, distribuidores, revendedores y terceras partes.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Finalmente, Bexen Cardio deberá colaborar con los responsables del tratamiento en la medida que sea posible para ayudarles al cumplimiento de sus obligaciones.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                ¿Cuáles son las responsabilidades de las entidades/clientes contratantes?
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Es responsabilidad del responsable el atender las solicitudes de acceso, rectificación, supresión, limitación, portabilidad y/o oposición de los datos de los
                interesados que se lo soliciten.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Si bien, Bexen Cardio ayudará en la medida de lo posible a los responsables a llevar a cabo estas solicitudes, bien a través de herramientas presentes en el mismo
                servicio o bajo solicitud directa a Bexen Cardio; dependiendo de la naturaleza de la solicitud.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Finalmente, Bexen Cardio no realiza tratamiento que pueda derivar en decisiones individuales automatizadas (como la realización de perfiles). De forma similar, el
                responsable no debería realizar estos tratamientos con ninguno de los datos presentes en los servicios sin el previo consentimiento de los individuos afectados.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h3" component="h3" style={{ marginTop: 30, textAlign: "justify" }}>
                Uso de los Servicios
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Este apartado define el uso esperado de los servicios como usuario registrado, y no alteran de ninguna forma el contrato por escrito contraído entre Bexen Cardio y
                la entidad y/o cliente que contrató los servicios, ni el contrato “Marco de Licencia de Software / Reanibex 100”.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                Reanibex Data Net
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Reanibex Data Net es un servicio que acompaña a los equipos Reanibex 100 y permite la monitorización del estado de estos equipos, así como la gestión de flota de
                otros modelos de equipos y equipos de la competencia.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Los Clientes que contraten el servicio durante la adquisición de un Reanibex 100, podrán crear una cuenta para gestionar los dispositivos. En esta cuenta se podrán
                crear usuarios registrados. Estos usuarios registrados serán configurados por el Cliente y no Bexen Cardio.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Los usuarios pueden - dependiendo de sus privilegios - principalmente ver la lista de los equipos disponibles, revisar el estado de los equipos Reanibex 100,
                configurar actualizaciones para los equipos Reanibex 100, localizar equipos, organizar equipos en grupos…
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                Reanibex USB Sync
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Reanibex USB Sync es una aplicación de escritorio para equipos Windows 10 en adelante que permite a los usuarios registrados comunicar los equipos Reanibex 100 con
                el servicio Reanibex Data Net.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Al conectar un equipo Reanibex 100 al ordenador por USB, la aplicación hace de puente entre el equipo Reanibex 100 y el servicio Reanibex Data Net. Esta aplicación
                permite a los usuarios registrados en Reanibex Data Net - con los privilegios correspondientes - subir tests (para actualizar el estado del equipo), subir datos de
                eventos generados por el equipo - todos los datos de eventos generados por el equipo Reanibex 100 son anónimos -, actualizar la configuración del equipo y
                actualizar la versión del equipo.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                Reanibex NFC Reader
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Reanibex NFC Reader es una aplicación para Smartphone que permite revisar el estado de los equipos Reanibex 100 la tecnología NFC de los móviles. Esta aplicación
                permite que al acercar un dispositivo móvil dotado de NFC a un equipo Reanibex 100, sea posible ver el estado del equipo.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Los usuarios registrados en el servicio Reanibex Data Net que hayan contratado la opción de NFC Reader, podrán usar la aplicación para revisar el estado de,
                únicamente, sus equipos Reanibex 100 y hacer configuraciones básicas que no afecten al funcionamiento del dispositivo.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                Reanibex Training
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Reanibex training tiene como objetivo la formación de los voluntarios en RCP y uso del desfibrilador. La plataforma proporciona contenido en diferentes módulos para
                que los usuarios adquieran conocimientos en el área. Cada módulo proporciona una sección de evaluación que el usuario tiene que superar para completar el curso de
                formación.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                En la plataforma, el usuario podrá refrescar las claves de la técnica RCP y así mantenerse en forma ante una para cardio-respiratoria. En caso de que el voluntario
                complete satisfactoriamente todos los módulos, se convertirá en un rescatador activo de la comunidad, permitiendo recibir alertas cuando se detecte una emergencia
                en su entorno cercano.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h4" component="h4" style={{ marginTop: 20 }}>
                Reanibex Alert
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Reanibex Alert tiene como objetivo alertar a la comunidad cuando se detecta una parada cardio-respiratoria. La app permite ver la ubicación de los desfibriladores
                instalados en el entorno del usuario y consultar información sobre horarios de accesibilidad. Toda la información está disponible en varios idiomas.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 15 }}>
                Cuando se detecta una emergencia se enviará una notificación al usuario para avisarle. El usuario podrá ver la distancia a la que se encuentra y podrá aceptar o
                declinar el aviso. En caso de poder acudir a la emergencia, se le mostrará un mapa con las indicaciones hasta el lugar del evento. Una vez en el lugar, el usuario
                deberá de confirmar su presencia en la escena y se le mostrarán las indicaciones de los siguientes pasos. Desde la aplicación el usuario podrá “apagar” las alertas
                para que en caso de energía no sea notificado.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default index;
